import { BookingStatusLabel } from "@/lib/types";

// ---------------------- Props

interface BookingStatusIndicatorProps {
  status: BookingStatusLabel | null;
}

// ---------------------- Component

const BookingStatusIndicator = ({ status }: BookingStatusIndicatorProps) => {
  // --------- JSX

  return (
    <div>
      {status === BookingStatusLabel.Missed && (
        <span className="text-sm font-bold text-[#ff321c]">MISSED</span>
      )}
      {status === BookingStatusLabel.CheckedIn && (
        <span className="text-sm font-bold text-[#0cb307]">CHECKED IN</span>
      )}
      {status === BookingStatusLabel.Late && (
        <span className="text-sm font-bold text-[#ffab03]">LATE</span>
      )}
    </div>
  );
};

export default BookingStatusIndicator;
